export const CMECONSTANT = [
    {
        'creditTypeId': '1',
        'creditTypeName': 'CME',
        'computedName': 'CME',
    },
    {
        'creditTypeId': '2',
        'creditTypeName': 'Nurse CE',
        'computedName': 'CE',
    },
    {
        'creditTypeId': '3',
        'creditTypeName': 'Pharmacist CE',
        'computedName': 'CE',
    },
    {
        'creditTypeId': '4',
        'creditTypeName': 'Psychologist CE',
        'computedName': 'CE',
    },
    {
        'creditTypeId': '5',
        'creditTypeName': 'CMLE',
        'computedName': 'CMLE',
    },
    {
        'creditTypeId': '7',
        'creditTypeName': 'Nurse Practitioner CE',
        'computedName': 'CE',
    },
    {
        'creditTypeId': '8',
        'creditTypeName': 'Physician Assistant CE',
        'computedName': 'CE',
    },
    {
        'creditTypeId': '9',
        'creditTypeName': 'MOC Credit',
        'computedName': 'ABIM MOC',
    }
]